export default __webpack_public_path__ + "static/media/MuseoSans_500-webfont.25cd48e6.woff2";